// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_spinner__GDkQt","spin":"spinner_spin__gvBkZ","spinner--small":"spinner_spinner--small__TWdt6","spinner--large":"spinner_spinner--large__VLuBF"};